__turbopack_context__.v({
  "fallback": "ReviewAvatar-module__k3knnW__fallback",
});
